<template>
  <router-link
    tag="div"
    :to="{ name: 'session-view', params: { id: training.id } }"
    class="training-info link-nostyle"
  >
    <template v-if="isTrainingStandard">
      <div>
        <svg-icon
          :name="'clock'"
          :width="20"
          :height="20"
          :fill="getFillColor(training, 1)"
          class="mr-2"
        ></svg-icon>
        <training-duration :training="training" :from="isFromString"></training-duration>
      </div>
      <div class="mt-2">
        <svg-icon
          :name="'heart_rate'"
          :width="19"
          :height="20"
          :fill="getFillColor(training, 2)"
          class="mr-2"
        ></svg-icon>
        {{ holdHRStr }}
      </div>
    </template>

    <template v-else>
      <div>
        <span
          style="padding: 1px 8px;
                         background: #3F4156;
                         color: white;
                         border-radius: 6px;
                         font-size: 16px;"
        >
          {{ $t('src/pages/trainingview.wt6m') }}
        </span>
      </div>
      <div class="mt-2">
        <svg-icon :name="'steps_fill'" :width="20" :height="20" class="mr-1"></svg-icon>
        <span>{{ getDistance(training) }}</span>
      </div>
    </template>

    <div class="text-tiny training-status" :class="[`training-status-${getStatusColor(training)}`]">
      {{ getStatusTitle(training) }}
    </div>

    <svg-icon
      v-if="isCanRemove(training) && hasRightsToEdit"
      @click:icon="removeTraining(training.id)"
      class="icon-remove-training"
      :name="'cross'"
      :width="12"
      :height="12"
    ></svg-icon>
  </router-link>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
import TrainingDuration from '@/components/Training/TrainingDuration.vue'
import { status } from '@/main.config'
import { trainingItem } from '@/mixins/training-item.js'

export default {
  name: 'TrainingDayDetails',
  mixins: [trainingItem],
  components: {
    TrainingDuration,
    SvgIcon
  },
  props: {
    training: {
      type: Object,
      required: true
    },
    hasRightsToEdit: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    isFromString() {
      return this.training.status === status.done && this.training.is_error_in_done_session === 1
    }
  },
  methods: {
    removeTraining() {
      this.$emit('remove', this.training.id)
    }
  }
}
</script>
